import { Component, Vue, Watch } from 'vue-property-decorator'
import HighFilter from '@/components/highFilter/index.vue'
import { UserModule } from '@/store/modules/user'
@Component({ name: 'ProjectResults', components: { HighFilter } })
export default class ProjectResults extends Vue {
  private shareVisible = false
  private shareNextVisible = false
  private deteleVisible = false

  private pageType: any = ''
  private taVal: any = null
  private templateVisible = false
  private deteleIconVisible = false
  private templateValue: any = ''
  private searchVal: any = ''
  private clickTableData: any = []
  private hoverIndex: any = ''

  created () {
    // 1 .项目成果 2.项目资料
    this.pageType = this.$route.meta.type
  }

  @Watch('$route')
  routeChange (val: any) {
    this.deteleIconVisible = false
    this.clickTableData = []
    this.hoverIndex = ''
    this.pageType = this.$route.meta.type // 1.项目成果 2.项目资料
  }

  // 项目成果
  private initProjectResults () {
    console.log(1)
  }

  // 项目资料
  private initProjectinformation () {
    console.log(2)
  }

  // input搜索框
  private inputChange () {
    console.log(this.searchVal)
  }

  // 删除
  private deleteClick () {
    console.log(23)
  }

  // 新建文件夹
  addFile () {
    console.log(222)
  }

  // 弹框删除
  sureDetele () {
    console.log(22)
  }

  clickTable (item: any) {
    const obj: any = {
      id: item
    }
    const itemIndex: any = this.clickTableData.findIndex((item1: any) =>
      item1.id === item)
    if (itemIndex > -1) {
      this.clickTableData.splice(itemIndex, 1)
    } else {
      this.clickTableData.push(obj)
    }
  }

  // // 确定发送
  // onMakeGroupSureClicked () {
  //   console.log(22)
  // }
  mouse (item: any, index: any) {
    this.hoverIndex = index
  }

  // 查看明细
  seeDetail (item: any, type: any) {
    this.$router.push({ path: 'project_result_detail', query: { type: this.pageType } })
  }
}
